"use client";

/**
 * Search 컴포넌트
 * @description 검색 입력. 앱 DS `Search` 의 웹 포팅. 값을 지우는 버튼은 값이 있을 때만 선다.
 * @example
 * <Search value={q} onValueChange={setQ} placeholder="Search artists" clearLabel="Clear" />
 */
import { Search as SearchIcon, X } from "lucide-react";
import { memo } from "react";

import { searchStyles } from "./Search.styles";
import type { SearchProps } from "./Search.types";

/** 시안의 필드 글리프 — `size.icon.md` */
const ICON_SIZE = 24;

const Search = memo<SearchProps>(
  ({
    value,
    onValueChange,
    placeholder,
    clearLabel,
    disabled = false,
    onFocus,
    onBlur,
  }) => (
    <div className={searchStyles.root({ disabled })}>
      <SearchIcon aria-hidden size={ICON_SIZE} className={searchStyles.icon} />
      <input
        type="search"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(event) => onValueChange(event.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        className={searchStyles.field}
      />
      {value ? (
        <button
          type="button"
          onClick={() => onValueChange("")}
          aria-label={clearLabel}
          className={searchStyles.clear}
        >
          <X aria-hidden size={ICON_SIZE} />
        </button>
      ) : null}
    </div>
  ),
);

Search.displayName = "Search";

export default Search;
